<template>
  <div class="top-buttons">
    <div>
      <GreetDrawer v-show="showLogo">
        <template #activator="{ toggle }">
          <button type="button" class="greet-logo" @click="toggle">
            <GreetLogo :width="74.4" :height="24" color="white" />
          </button>
        </template>
      </GreetDrawer>
    </div>
    <div class="right-buttons">
      <v-btn
        v-if="showPaymentHistoryButton && !showLogo"
        depressed
        rounded
        class="history-icon"
        data-cy="payment-history-button"
        @click="navigateToPaymentHistory"
      >
        <v-icon left color="black">
          mdi-history
        </v-icon>
        <div class="tp-text-body-2 tp-normal-spacing">
          {{ $t('screens.selectScreen.paymentsCta') }}
        </div>
      </v-btn>
      <button
        v-if="$store.getters.restaurantHasLanguages"
        type="button"
        class="top-button language-button"
        @click="toggleLanguageSelector"
      >
        <img :src="currentLanguage.image" class="language-button__flag" />
        <span class="language-button__label">{{ currentLanguage.name }}</span>
      </button>
      <button
        v-if="showProfileButton"
        type="button"
        class="top-button profile-button"
        data-cy="login"
        @click="navigateToProfile"
      >
        <img
          v-if="userPhotoUrl"
          :src="userPhotoUrl"
          :alt="user?.email"
          class="profile-button__photo"
        />
        <CtaIcon v-else name="userRound" :size="20" color="#262626" />
      </button>
    </div>
  </div>
</template>

<script>
import GreetLogo from '@/components/GreetLogo.vue';
import GreetDrawer from '@/components/SplashScreen/GreetDrawer.vue';
import CtaIcon from '@/components/SplashScreen/CtaIcon.vue';
import { getLanguageByCode } from '@/utils/languages';

export default {
  components: {
    GreetLogo,
    GreetDrawer,
    CtaIcon,
  },
  props: {
    showLogo: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showPaymentHistoryButton() {
      return this.$store.getters.functionalityPayGoEnabled;
    },
    currentRestaurantId() {
      return this.$store.getters.getCurrentRestaurantId;
    },
    restaurantLoyaltyProgram() {
      return this.$store.getters.restaurantLoyaltyProgram();
    },
    loyaltyProgramEnabled() {
      return this.$store.getters.functionalityLoyaltyProgramEnabled;
    },
    showProfileButton() {
      return this.loyaltyProgramEnabled;
    },
    userPhotoUrl() {
      return this.$store.getters.userProfilePhoto;
    },
    user() {
      return this.$store.getters.user;
    },
    currentLanguage() {
      const code = this.$i18n.locale();
      return (
        getLanguageByCode(code) || {
          name: code.toUpperCase(),
          image: require(`@/assets/images/flags/${code}.svg`),
        }
      );
    },
  },
  methods: {
    toggleLanguageSelector: function() {
      this.$store.dispatch('openLanguageSelector');
      this.$store.dispatch('sendAnalyticsEvent', {
        event: 'language_selector_opened',
      });
    },
    navigateToPaymentHistory: function() {
      this.$router.push({ name: 'PaymentHistory' });
    },
    navigateToProfile: function() {
      this.$router.push({
        name: 'Profile',
        params: {
          session: this.$store.state.session,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.top-buttons {
  z-index: 150 !important;
  position: absolute;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // Logo sits 16px below the status bar; the 40px buttons stay centred with it.
  padding: calc(8px + env(safe-area-inset-top, 0px)) 14px 8px 16px;
  flex-direction: row;
  width: 100%;
  gap: 8px;
  @media screen and (min-width: $max-app-width) {
    max-width: $max-app-width;
    margin: 0 auto;
  }
}

.right-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.greet-logo {
  display: flex;
  align-items: center;
  height: 40px;
  margin-left: 6px;
}

.history-icon {
  height: 40px !important;
}

.top-button {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  border-radius: 20px;
  background: #f5f5f5;
  overflow: hidden;
}

.language-button {
  gap: 4px;
  padding: 0 16px 0 12px;

  &__label {
    font-family: 'Poppins', sans-serif !important;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: #262626;
  }

  &__flag {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    object-fit: cover;
  }
}

.profile-button {
  width: 40px;

  &__photo {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
